/**
 * /app/$tenantSlug/hiring/analytics — HR-admin hiring analytics dashboard
 * (Wave K5.1). The deep recruiter-velocity / quality view: stage-event
 * funnel, time-in-stage, time-to-fill/hire, offer/source/recruiter/
 * interviewer metrics, req-aging, renege, quality-of-hire.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { AnalyticsTab } from "@/components/hiring/analytics-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/analytics",
)({
  component: HiringAnalyticsRoute,
});

function HiringAnalyticsRoute() {
  return (
    <HiringModuleShell
      title="Analytics"
      description="Funnel conversion, time-in-stage, offer and quality metrics."
    >
      <HiringFeatureGate>
        <AnalyticsTab />
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
